// 👇 ...imports
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import rateCardItems from './rateCardData';
import { AIRTABLE_URL, AIRTABLE_HEADERS, SHEET_URL } from "./constants";

export default function TechnicianDashboard() {
  const [assignedServices, setAssignedServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [extraPartsMap, setExtraPartsMap] = useState({});
  const [orderPartsMap, setOrderPartsMap] = useState({});
  const [techSearch, setTechSearch] = useState("");
  const [submittingId, setSubmittingId] = useState(null);
  const [workSubmittingId, setWorkSubmittingId] = useState(null);
  const [paidSubmittingId, setPaidSubmittingId] = useState(null);

  const navigate = useNavigate();

  // ✅ Yeh line add kar — ye sabse zaroori hai
  const location = useLocation();
  const technicianPhone = location.state?.technicianPhone || localStorage.getItem("technicianPhone");

  useEffect(() => {

   const fetchAssignedServices = async () => {
  try {
    const res = await fetch(AIRTABLE_URL, {
      headers: AIRTABLE_HEADERS,
    });

    const data = await res.json();

    const services = data.records.map(record => ({
      airtableRecordId: record.id,
      ...record.fields
    }));

    const assigned = services.filter(
      (s) => s.assignedTechnicianPhone === technicianPhone
    );

    setAssignedServices(assigned);
  } catch (error) {
    console.error("Error fetching assigned services:", error);
  }
};

      const loadAllData = async () => {
      await fetchAssignedServices();
      setLoading(false);
    };

    loadAllData();
  }, [technicianPhone]);

const calculateServiceTotal = (services) => {
  if (!services) return 0;

  let total = 0;
  const list = Array.isArray(services)
    ? services
    : services.split(",").map(item => item.trim()).filter(Boolean);

  for (let item of list) {
    // Normalize ₹₹, extra spaces, and lower/uppercase x
    const cleanItem = item.replace(/₹₹/g, "₹").replace(/\s+/g, " ").trim();

    const match = cleanItem.match(/₹\s*(\d+)\s*[xX]\s*(\d+)/);
    if (match) {
      const price = parseInt(match[1], 10);
      const qty = parseInt(match[2], 10);
      total += price * qty;
    } else {
      const priceOnly = cleanItem.match(/₹\s*(\d+)/);
      if (priceOnly) {
        total += parseInt(priceOnly[1], 10);
      }
    }
  }

  return total;
};



  const saveToTechnicianHistory = (booking) => {
  const prev = JSON.parse(localStorage.getItem("technicianHistory")) || [];

  const serviceTotal = calculateServiceTotal(booking.services); // ✅ Yeh naya hai
  const extraPartsTotal = calculatePartsTotal(booking.updatedServices); // ✅ Parts ka total bhi yeh karega

  const newEntry = {
    orderId: booking.orderId,
    name: booking.name,
    phone: booking.phone,
    address: booking.address,
    services:
      Array.isArray(booking.services) ? booking.services.join(", ") : booking.services,
    serviceTotal: serviceTotal,
    extraParts: booking.updatedServices || "None",
    extraPartsTotal: extraPartsTotal,
    grandTotal: serviceTotal + extraPartsTotal,
    approved: booking.approved || false
  };

  localStorage.setItem("technicianHistory", JSON.stringify([...prev, newEntry]));
};

const calculatePartsTotal = (str) => {
  if (!str) return 0;

  const parts = str
    .split(",")
    .map(part => part.trim().replace(/₹₹/g, "₹"))
    .filter(Boolean);

  let total = 0;

  for (let part of parts) {
    const match = part.match(/₹\s*(\d+)/);
    if (match) {
      total += parseInt(match[1], 10);
    }
  }
  
  return total;
};

 useEffect(() => {
  const fetchParts = async () => {
    const map = {};
    const filteredBookings = [];

    for (const s of assignedServices) {
      const formula = `{orderId} = '${s.orderId}'`;
      const res = await fetch(
        `${SHEET_URL}?filterByFormula=${encodeURIComponent(formula)}`,
        {
          headers: AIRTABLE_HEADERS,
        }
      );

      const data = await res.json();
      const record = data.records?.[0]?.fields;

      if (
        record &&
        record.cancelled !== "TRUE" &&
        record.paid !== "TRUE" &&
        record.paid !== true &&
        record.paid !== "true"
      ) {
        filteredBookings.push({ ...record, airtableRecordId: data.records[0].id });
      }

      map[s.orderId] = record?.extraParts
        ? record.extraParts.split(",").map((part) => {
            const [desc, price] = part.trim().split(" - ");
            return { desc: desc?.trim(), price: price?.trim() };
          })
        : [];
    }

    setBookings(filteredBookings);
    setOrderPartsMap(map);
    setExtraPartsMap(map);
  };

  if (assignedServices.length > 0) {
    fetchParts();
  }
}, [assignedServices]);

const handleReject = async (service) => {
  const confirmReject = window.confirm("Are you sure you want to reject this order?");
  if (!confirmReject) return;

  setSubmittingId(service.orderId);

 try {
  const res = await fetch(
    `${SHEET_URL}?filterByFormula={orderId}='${service.orderId}'`,
    {
      headers: AIRTABLE_HEADERS,  // ✅ constants.js ka centralized headers
    }
  );

    const data = await res.json();
    const record = data.records[0];

    if (!record) {
      alert(`❌ Order ID ${service.orderId} not found in Airtable`);
      return;
    }

    const recordId = record.id;

    // ✅ Update Airtable with rejection + clear technicianPhone
   await fetch(`${SHEET_URL}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS,   // ✅ centralized headers from constants.js
  body: JSON.stringify({
    records: [
      {
        id: recordId,
        fields: {
          technicianStatus: `Rejected by ${technicianPhone}`,
          assignedTechnicianPhone: "",
        },
      },
    ],
  }),
});


    alert(`❌ ${service.orderId} rejected by ${technicianPhone}`);

    // ✅ Remove from UI without refresh
    setServices((prev) => prev.filter((s) => s.orderId !== service.orderId));
  } catch (err) {
    console.error(err);
    alert("❌ Failed to reject order");
  } finally {
    setSubmittingId(null);
  }
};

const handleFakeOrder = async (service) => {
  const confirmFake = window.confirm("Mark this order as Fake?");
  if (!confirmFake) return;
  setSubmittingId(service.orderId);

 try {
  const res = await fetch(
    `${SHEET_URL}?filterByFormula=${encodeURIComponent(`{orderId}='${service.orderId}'`)}`,
    {
      headers: AIRTABLE_HEADERS, // ✅ constants.js se import kiya hua
    }
  );

    const data = await res.json();
    const record = data.records[0];

    if (!record) {
      alert(`❌ Order ID ${service.orderId} not found in Airtable`);
      return;
    }

    const recordId = record.id;

    await fetch(`${SHEET_URL}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS,   // ✅ centralized headers from constants.js
  body: JSON.stringify({
    records: [
          {
            id: recordId,
           fields: {
                    technicianStatus: `Fake order by ${technicianPhone}`,
                    assignedTechnicianPhone: ""
            },
          },
        ],
      }),
    });

    // 🔥 Remove from UI
    setServices((prev) => prev.filter((s) => s.orderId !== service.orderId));
   } catch (err) {
    console.error(err);
    alert("❌ Failed to mark fake order");
  } finally {
    setSubmittingId(null); // reset button state
  }
};

  const updateSheet = async (recordId, updatedParts) => {
  const formattedParts = updatedParts.map(p => `${p.desc} - ${p.price}`).join(", ");
  
  const partsTotal = updatedParts.reduce((total, p) => {
    const price = typeof p.price === "string" 
      ? parseFloat(p.price.replace(/[₹\s]/g, "")) 
      : parseFloat(p.price);
    return total + (isNaN(price) ? 0 : price);
  }, 0);

try {
  const extraPartsTotal = Math.round(partsTotal * 100) / 100;

  // Step 1: Fetch current record from Sheet1
  const res = await fetch(`${SHEET_URL}/${recordId}`, {
    headers: AIRTABLE_HEADERS, // ✅ constants.js wala headers
  });

const data = await res.json();
const serviceTotal = parseFloat(data.fields?.serviceTotal) || 0;
const grandTotal = Math.round((serviceTotal + extraPartsTotal) * 100) / 100;

  // Step 2: Update the record
const updateRes = await fetch(`${SHEET_URL}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS, // ✅ constants.js wala use karo
  body: JSON.stringify({
    records: [
      {
        id: recordId,
        fields: {
          extraParts: formattedParts,
          extraPartsTotal: extraPartsTotal,
          grandTotal: grandTotal,
        },
      },
    ],
  }),
});

    const updateData = await updateRes.json();

    if (!updateRes.ok) {
      console.error("❌ Airtable update failed:");
      console.error("Status Code:", updateRes.status);
      console.error("Message:", updateData?.error?.message);
      console.error("Problematic Fields:", updateData?.error?.fields);
      return;
    }

    console.log(`✅ Successfully updated Airtable record: ${recordId}`);
  } catch (err) {
    console.error("❌ Unexpected error while updating Airtable:", err);
  }
};

const markWorkComplete = async (service) => {
  try {
    setSubmittingId(service.id); // Start loading this row's button

  const response = await fetch(`${SHEET_URL}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS, // ✅ constants.js se centralized headers
  body: JSON.stringify({
    records: [
      {
        id: service.airtableRecordId,
        fields: {
          workCompleted: "true",
        },
      },
    ],
  }),
});


    const data = await response.json();
    if (data.error) throw new Error(data.error.message);

    saveToTechnicianHistory(service);
    alert("Work marked as complete ✅");
  } catch (error) {
    console.error("Error:", error);
    alert("Failed to mark complete ❌");
  } finally {
    setSubmittingId(null); // Reset loading state
  }
};

const markAsPaid = async (service) => {
  try {
    setSubmittingId(service.id); // Start loading this row's button

  const response = await fetch(`${SHEET_URL}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS, // ✅ centralized headers from constants.js
  body: JSON.stringify({
    records: [
      {
        id: service.airtableRecordId,
        fields: {
          paid: "true",
        },
      },
    ],
  }),
});


    const data = await response.json();
    if (data.error) throw new Error(data.error.message);

    saveToTechnicianHistory(service);
    alert("Marked as paid ✅");
  } catch (error) {
    console.error("Error:", error);
    alert("Failed to mark as paid ❌");
  } finally {
    setSubmittingId(null); // Reset loading state
  }
};
const unpaidServices = assignedServices.filter(
  service => service.paid !== "TRUE" && service.paid !== true && service.paid !== "true"
);
  return (
    <div style={{ paddingTop: 50, position: "relative", width: "100vw", margin: 0, maxWidth: "100%", boxSizing: "border-box" }}>
      <button onClick={() => navigate("/technician-home")} style={{ position: "absolute", top: 10, right: 10, fontSize: 18, background: "none", border: "none", cursor: "pointer" }}>✖</button>
    
      {loading ? (
      <p>Loading technician data...</p>
    ) : unpaidServices.length === 0 ? (
      <p>No new services assigned yet.</p>
    ) : (
      unpaidServices.map((service, index) => {
        const parts = extraPartsMap[service.orderId] || [];

         let serviceTotal = 0;
const serviceLine = Array.isArray(service.services) 
  ? service.services.join(", ") 
  : service.services;

// 1) Regex se ₹price aur qty dono pakdo
const regex = /₹\s?(\d+)\s*[xX]\s*(\d+)/g;
let match;
const matchedIndexes = []; // track already used parts

while ((match = regex.exec(serviceLine)) !== null) {
  const price = parseInt(match[1], 10);
  const qty = parseInt(match[2], 10);
  if (!isNaN(price) && !isNaN(qty)) {
    serviceTotal += price * qty;
    matchedIndexes.push(match.index); // mark as handled
  }
}

// 2) Ab sirf wahi ₹amount add karo jisme quantity nahi hai
const priceOnlyRegex = /₹\s?(\d+)/g;
let priceMatch;
while ((priceMatch = priceOnlyRegex.exec(serviceLine)) !== null) {
  const price = parseInt(priceMatch[1], 10);
  if (!isNaN(price)) {
    // check ki ye part already "₹xxx x qty" me use na hua ho
    const alreadyCounted = matchedIndexes.some(i => 
      priceMatch.index >= i && priceMatch.index < i + priceMatch[0].length
    );
    if (!alreadyCounted) {
      serviceTotal += price;
    }
  }
}


          const partsTotal = parts.reduce((total, p) => {
            let part = typeof p === "string"
              ? (() => {
                  const [desc, price] = p.split(" - ");
                  return { desc: desc?.trim(), price: price?.trim() };
                })()
              : p;

            const match = part.price?.match(/₹\s?(\d+)/);
            const amount = match ? parseInt(match[1]) : 0;
            return total + (isNaN(amount) ? 0 : amount);
          }, 0);

          const grandTotal = serviceTotal + partsTotal;

          return (
            <div key={index} style={{ border: "1px solid #ccc", padding: 5, marginBottom: 5 }}>
              <p><b>Order ID:</b> {service.orderId || "N/A"}</p>
              <p><b>Customer:</b> {service.name || service.customer || "N/A"}</p>
              <p><b>Phone:</b> {service.phone || "N/A"}</p>
              <p><b>Address:</b> {service.address || "N/A"}</p>
              <p><b>Services:</b> {serviceLine}</p>
              <p><b>Service Total:</b> ₹{serviceTotal.toFixed(2)}</p>
              <p style={{ color: "red", fontWeight: "bold" }}>⚠️ Please call customer before reaching his/her location.</p>

              {/* Technician Search Input */}
              <input
                type="text"
                placeholder="Type to search and select an extra part"
                value={techSearch}
                onChange={(e) => setTechSearch(e.target.value)}
                disabled={service.paid?.toString().toLowerCase() === "true"}
                style={{
                  padding: "6px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "100%",
                  boxSizing: "border-box",
                  borderRadius: 4,
                  border: "1px solid #ccc"
                }}
              />

              {/* Filtered Dropdown */}
              <select
                onChange={(e) => {
                  if (!e.target.value) return;
                  const selected = JSON.parse(e.target.value);
                  const updated = [...parts, selected];
                  setExtraPartsMap((prev) => ({
                    ...prev,
                    [service.orderId]: updated
                  }));
                  updateSheet(service.airtableRecordId, updated);
                }}
                disabled={service.paid?.toString().toLowerCase() === "true"}
                style={{
                  padding: "6px",
                  marginTop: "10px",
                  opacity: service.paid?.toString().toLowerCase() === "true" ? 0.6 : 1,
                  cursor: service.paid?.toString().toLowerCase() === "true" ? "not-allowed" : "pointer",
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box"
                }}
              >
                <option value="">➕ Select Extra Part</option>
                {rateCardItems
                  .filter((item) =>
                    item.desc.toLowerCase().includes(techSearch.toLowerCase())
                  )
                  .map((item) => (
                    <option key={item.desc} value={JSON.stringify(item)}>
                      {item.desc} - ₹{item.price}
                    </option>
                  ))}
              </select>

              <ul style={{ marginTop: 10, listStyleType: "none", paddingLeft: 0 }}>
                {parts.map((p, idx) => {
                  const part = typeof p === "string" ? JSON.parse(p) : p;
                  return (
                   <li key={idx} style={{ marginBottom: 5 }}>
  {part.desc} — {part.price?.includes("₹") ? part.price : `₹${part.price}`}
  <button
    onClick={() => {
      const updatedList = parts.filter((_, i) => i !== idx);
      setExtraPartsMap(prev => ({
        ...prev,
        [service.orderId]: updatedList
      }));
      updateSheet(service.airtableRecordId, updatedList);
    }}
    disabled={service.paid?.toString().toLowerCase() === "true"}
    style={{
      marginLeft: 10,
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "2px 8px",
      borderRadius: 3,
      cursor: service.paid?.toString().toLowerCase() === "true" ? "not-allowed" : "pointer",
      opacity: service.paid?.toString().toLowerCase() === "true" ? 0.5 : 1
    }}
  >
    Remove
  </button>
</li>

                  );
                })}
              </ul>

              <p><b>Extra Parts Total:</b> ₹{partsTotal.toFixed(2)}</p>
              <p><b>Grand Total:</b> ₹{grandTotal.toFixed(2)}</p>

              {service.status === "approved" && (
                <p style={{ color: "green", fontWeight: "bold" }}>✅ Customer has approved the extra parts</p>
              )}
              {service.status === "cancelled" && (
                <p style={{ color: "red", fontWeight: "bold" }}>❌ Customer has cancelled the extra parts. Please remove them from your side as well</p>
              )}

              {!service.workCompleted && (
<button
  onClick={() => {
    setWorkSubmittingId(service.airtableRecordId); // ✅ unique key
    markWorkComplete(service).finally(() => {
      setWorkSubmittingId(null);
      setAssignedServices(prev =>
        prev.map(s =>
          s.airtableRecordId === service.airtableRecordId // ✅ compare properly
            ? { ...s, workCompleted: true }
            : s
        )
      );
    });
  }}
  disabled={workSubmittingId === service.airtableRecordId}
  style={{
    backgroundColor:
      workSubmittingId === service.airtableRecordId ? "#6c757d" : "#28a745",
    color: "#fff",
    padding: "6px 4px",
    border: "none",
    marginTop: "10px",
    marginRight: 5,
    cursor:
      workSubmittingId === service.airtableRecordId
        ? "not-allowed"
        : "pointer"
  }}
>
  {workSubmittingId === service.airtableRecordId ? "Submitting..." : "Work Complete"}
</button>
)}

{!service.paid && (
 <button
  onClick={() => {
    setPaidSubmittingId(service.airtableRecordId); // ✅ unique key
    markAsPaid(service).finally(() => {
      setPaidSubmittingId(null);
      setAssignedServices(prev =>
        prev.map(s =>
          s.airtableRecordId === service.airtableRecordId // ✅ compare properly
            ? { ...s, paid: "TRUE" }
            : s
        )
      );
    });
  }}
  disabled={paidSubmittingId === service.airtableRecordId}
  style={{
    backgroundColor:
      paidSubmittingId === service.airtableRecordId ? "#6c757d" : "#28a745",
    color: "#fff",
    padding: "6px 4px",
    border: "none",
    marginTop: "10px",
    marginRight: 5,
    cursor:
      paidSubmittingId === service.airtableRecordId
        ? "not-allowed"
        : "pointer"
  }}
>
  {paidSubmittingId === service.airtableRecordId ? "Submitting..." : "Paid"}
</button>
)}

              {service.paid === "TRUE" && (
                <p style={{ color: "green", fontWeight: "bold", marginTop: "10px" }}>
                  💰 Payment Received
                </p>
              )}

<button
  onClick={() => {
    setSubmittingId(service.airtableRecordId); // ✅ unique key
    handleReject(service).finally(() => {
      setSubmittingId(null);
      setAssignedServices(prev =>
        prev.filter(s => s.airtableRecordId !== service.airtableRecordId) // ✅ correct comparison
      );
    });
  }}
  disabled={service.workCompleted === true || submittingId === service.airtableRecordId}
  style={{
    backgroundColor: service.workCompleted || submittingId === service.airtableRecordId ? "#ccc" : "red",
    color: "white",
    padding: "6px 4px",
    border: "none",
    cursor: service.workCompleted ? "not-allowed" : "pointer"
  }}
>
  {submittingId === service.airtableRecordId ? "Submitting..." : "Reject"}
</button>

  <button
  onClick={() => {
    setSubmittingId(service.airtableRecordId); // ✅ unique key
    handleFakeOrder(service).finally(() => {
      setSubmittingId(null);
      setAssignedServices(prev =>
        prev.filter(s => s.airtableRecordId !== service.airtableRecordId) // ✅ correct comparison
      );
    });
  }}
  disabled={service.workCompleted === true || submittingId === service.airtableRecordId}
  style={{
    marginLeft: 5,
    backgroundColor: service.workCompleted || submittingId === service.airtableRecordId ? "#ccc" : "red",
    color: "white",
    padding: "6px 4px",
    border: "none",
    marginTop: 10,
    cursor: service.workCompleted ? "not-allowed" : "pointer"
  }}
>
  {submittingId === service.airtableRecordId ? "Submitting..." : "Mark Fake"}
</button>

            </div>
          );
        })
    )}
    </div>
  );
}



